'use client';

import {track} from 'iq-tracking';

interface RelatedGuideLinkProps {
  href: string;
  slug: string;
  children: React.ReactNode;
}

// Thin client wrapper so the RSC parent (related_guides.tsx) can attach
// click tracking without losing its server-component data-fetching benefits.
export function RelatedGuideLink({href, slug, children}: RelatedGuideLinkProps) {
  return (
    <a
      href={href}
      onClick={() =>
        void track({
          event: 'related_guide_clicked',
          action: 'click',
          component: 'module',
          content_type: 'guide',
          content_identifier: slug,
        })
      }
      className='text-sm py-3 border-t border-gray-100 hover:underline text-gray-700 leading-snug'>
      {children}
    </a>
  );
}
